const embedYouTubeVideo = () => {
    const initializeVideo = (): void => {
        const videoContainer = document.querySelector<HTMLDivElement>('.embed-video-container');

        if (!videoContainer) {
            return;
        }

        const videoId = videoContainer.dataset.video_id;

        if (!videoId) {
            return;
        }

        const thumbnail = videoContainer.querySelector<HTMLImageElement>('.video-thumbnail');
        const playButton = videoContainer.querySelector('.play-button-overlay');

        const loadVideo = (): void => {
            const src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

            videoContainer.innerHTML = `
                <iframe class="youtube-iframe"
                        style="width: 100%; height: 100%;"
                        src="${src}"
                        title="YouTube Video Player"
                        allow="autoplay"
                        allowfullscreen
                ></iframe>`;
        };

        thumbnail?.addEventListener('click', loadVideo);
        playButton?.addEventListener('click', loadVideo);
    };

    initializeVideo();
};

document.addEventListener('DOMContentLoaded', embedYouTubeVideo);
